'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext } from 'react';
import { ClerkAuthContext, ClerkAuthProvider } from './ClerkAuthProvider';
import { KeycloakAuthContext, KeycloakAuthProvider } from './KeycloakAuthProvider';
import type { AuthState } from './types';
import { isKeycloakAuth } from '@/lib/auth/authConfig';

// Unified context that delegates to the appropriate provider
const UnifiedAuthContext = createContext<AuthState | null>(null);
export function AuthProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  if (isKeycloakAuth) {
    let t1;
    if ($[0] !== children) {
      t1 = <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <ClerkAuthProvider>{children}</ClerkAuthProvider>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function useAuth() {
  const keycloakCtx = useContext(KeycloakAuthContext);
  const clerkCtx = useContext(ClerkAuthContext);
  const ctx = isKeycloakAuth ? keycloakCtx : clerkCtx;
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
}

// Legacy alias
export const useFirebaseAuth = useAuth;